import React from "react";
import "../style/SearchDropDown.css";

const SearchDropDown = (props) => {
  return (
    <div style={{ position: "relative" }}>
      <input
        type="text"
        className="form-control"
        placeholder="Search"
        value={props.searchQuery}
        onChange={(e) => props.setSearchQuery(e.currentTarget.value)}
        onFocus={props.onSearchBarFocus}
        onBlur={props.onSearchBarBlur}
      />
      {props.searchBarFocus && props.allInfo && (
        <div
          className="search-dropdown"
          style={{
            position: "absolute",
            left: 0,
            right: 0,
            marginTop: "3px",
            border: "1px solid #929292",
            borderTop: "none",
            padding: "3px 0px",
            backgroundColor: "white",
          }}
        >
          <div
            style={{
              height: props.height || "275px",
              overflowY: "auto",
              padding: "0px 10px",
            }}
          >
            {props.filteredInfo.map((info, index, arr) => (
              <p
                key={index}
                style={{
                  cursor: "pointer",
                  borderBottom: index === arr.length - 1 ? "none" : "1px solid #929292",
                  margin: 0,
                  padding: "5px",
                }}
                onMouseDown={() => props.onInfoMouseDown(info)}
              >
                {info}
              </p>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchDropDown;
